import { css } from 'styled-components';

// Convert px to rem
export const rem = (px) => `${px / 16}rem`;

// Paddings
export const pt = (value) => `padding-top: ${value}rem`;
export const pr = (value) => `padding-right: ${value}rem`;
export const pb = (value) => `padding-bottom: ${value}rem`;
export const pl = (value) => `padding-left: ${value}rem`;

// Margins
export const mt = (value) => `margin-top: ${value}rem`;
export const mr = (value) => `margin-right: ${value}rem`;
export const mb = (value) => `margin-bottom: ${value}rem`;
export const ml = (value) => `margin-left: ${value}rem`;

export const getModifiers = ({ modifiers = [], ...props }, modifierProps) => {
  const base = typeof modifiers === 'string' ? [modifiers] : modifiers;
  const namedModifiers = Object.keys(props).filter((prop) => props[prop] && modifierProps.includes(prop));
  return [...base, ...namedModifiers];
};

export const label = (value, altLabel) => ({
  'placeholder': value,
  'title': value,
  'aria-label': value,
  'label': altLabel ?? value,
});

const identity = (item) => item;
const memoized = {};
export const themed = (path, postProcess = identity) => {
  if (memoized[path]) {
    return memoized[path];
  }

  try {
    const extractor = ({ theme }) => {
      return postProcess(path.split('.').reduce((result, field) => result[field], theme));
    };

    memoized[path] = extractor;
    return extractor;
  } catch (error) {
    console.error(error);
    console.error(`Could not extract item ${path} from theme`);
    return () => '';
  }
};

export const flex = (direction, justify, align) => css`
  display: flex;
  flex-direction: ${direction};
  justify-content: ${justify};
  align-items: ${align}
`;
